export const name = "DIV";
export const summary = `Divides integer \`X\` by integer \`Y\`.`;
export const reference = `
## DIV

Divides integer \`X\` by integer \`Y\`.

\`\`\`
DIV(X, Y)
\`\`\`

### Description

Returns the result of integer division of X by Y. Division by zero returns an error. Division by -1 may overflow.

| X | Y | DIV(X, Y) |
| --- | --- | --- |
| 20 | 4 | 5 |
| 12 | -7 | -1 |
| 20 | 3 | 6 |
| 0 | 20 | 0 |
| 20 | 0 | Error |


### Return Data Type

The return data type is determined by the argument types with the following table.

















| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` |
| --- | --- | --- | --- |
| \`INT64\` | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` |
| \`NUMERIC\` | \`NUMERIC\` | \`NUMERIC\` | \`BIGNUMERIC\` |
| \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` |




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
